import * as React from 'react';
import { Menu, MenuItem, Box, Button } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const TripDropdown = ({trips, tripFilter, setTripFilter}) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (trip) => {
    return () => {
        setTripFilter(trip);
        handleClose();
    }
  }

  return (
    <Box>
        <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            variant="outlined"
            sx={{color: 'white', border: '1px solid white', width: '250px', justifyContent: 'space-between'}}
            
        >
            {tripFilter  && tripFilter !== 'all-trips' ? tripFilter.title : "All Trips"}
            <ArrowDropDownIcon />
        </Button>
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
                list: {
                    'aria-labelledby': 'basic-button',
                },
            }}
        >
            <MenuItem  onClick={handleSelect("all-trips")}>All Trips</MenuItem>
            {trips.map(trip => <MenuItem key={trip._id} onClick={handleSelect(trip)}>{trip.title}</MenuItem>)}
            
        </Menu>
    </Box>
  );
}

export default TripDropdown;